// useClickWithTouchBackfill.js
import { useEffect, useRef } from 'react';

import createClickWithTouchBackfill from '../resource/createClickWithTouchBackfill.js';

/**
 * @param {object} params
 * @param {function} params.onClick - Click handler to backfill.
 * @returns {object} Stable event handler props to spread onto the target element.
 * @example
 * const clickProps = useClickWithTouchBackfill({ onClick: handleClick });
 * <button {...clickProps} />;
 */
const useClickWithTouchBackfill = ({ onClick } = {}) => {
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  const touchBackfillRef = useRef(null);
  if (!touchBackfillRef.current) {
    const instance = createClickWithTouchBackfill();
    touchBackfillRef.current = {
      cleanup: instance.cleanup,
      props: instance.bindClick({
        onClick: (...args) => onClickRef.current?.(...args),
      }),
    };
  }

  useEffect(() => () => touchBackfillRef.current.cleanup(), []);

  return touchBackfillRef.current.props;
};

export default useClickWithTouchBackfill;
